
import { EmptyRoutineState } from "./routines/EmptyRoutineState";
import { RoutineHeader } from "./routines/RoutineHeader";
import { RoutineCarousel } from "./routines/RoutineCarousel";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

interface TodayRoutinesSectionProps {
  todayRoutines: any[];
  hasAssignedRoutines: boolean;
  completedRoutines: any[];
  isLoadingRoutines?: boolean;
}

export const TodayRoutinesSection = ({ 
  todayRoutines, 
  hasAssignedRoutines,
  completedRoutines,
  isLoadingRoutines = false
}: TodayRoutinesSectionProps) => {
  const isRoutineCompleted = (routineId: string) => {
    return completedRoutines.some(cr => cr.routine_id === routineId);
  };

  // Mostrar loading mientras se cargan los datos
  if (isLoadingRoutines) {
    return (
      <div>
        <RoutineHeader hasRoutines={false} />
        <div className="bg-gradient-to-r from-primary/10 to-primary/20 border border-primary/20 rounded-xl p-6 text-center">
          <div className="animate-pulse space-y-3">
            <div className="h-4 bg-primary/20 rounded w-3/4 mx-auto"></div>
            <div className="h-4 bg-primary/20 rounded w-1/2 mx-auto"></div>
          </div>
          <p className="text-sm text-muted-foreground mt-4">Cargando tus rutinas...</p>
        </div>
      </div>
    );
  }

  if (!hasAssignedRoutines) {
    return <EmptyRoutineState />;
  }

  // Mostrar este mensaje cuando no hay rutinas para hoy
  if (!todayRoutines || todayRoutines.length === 0) {
    return (
      <div>
        <RoutineHeader hasRoutines={false} />
        <div className="bg-gradient-to-r from-primary/10 to-primary/20 border border-primary/20 rounded-xl p-6 text-center">
          <p className="text-lg text-white forest:text-forest sunset:text-sunset ocean:text-ocean mb-4">No tienes rutinas programadas para hoy</p>
          <Link to="/rutina">
            <Button 
              variant="outline" 
              className="border-primary hover:bg-primary/50 sunset:border-sunset sunset:hover:bg-sunset forest:border-forest forest:bg-forest ocean:border-ocean ocean:bg-ocean text-primary-foreground"
            >
              Ver todas mis rutinas
              <ChevronRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <RoutineHeader hasRoutines={true} />
      <RoutineCarousel 
        todayRoutines={todayRoutines}
        completedRoutines={completedRoutines}
        isRoutineCompleted={isRoutineCompleted}
      />
    </>
  );
};
